import { mapActions } from 'vuex';

export default {
  methods: {
    ...mapActions(['getArtworks']),
    updatedActiveValues(value) {
      let values = this.activeValues;
      if (values.includes(value)) {
        values = values.filter(e => e !== value);
      } else {
        values.push(value);
      }
      return values;
    },
    isActive(value) {
      return this.activeValues.includes(value);
    },
  },
};



// WEBPACK FOOTER //
// ./app/javascript/packs/shared/mixins/artworks_filters_helpers.js